import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as controller } from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ResourcesPeopleActiveController extends Controller {
  @controller('resources/people') peopleController;
  @service store;
  @service intl;

  queryParams = ['grouping'];
  get groupingLabel() {
    return this.intl?.t?.('people.group-by');
  }

  get groupingOptions() {
    return [
      { label: this.intl.t('people.team', { num: 1 }), value: 'team' },
      { label: this.intl.t('people.roles', { num: 1 }), value: 'role' },
    ];
  }

  @tracked grouping = null;

  @action
  setGrouping(e) {
    this.grouping = e.value;
  }

  @action
  onGroupingSelect(e) {
    this.grouping = this.grouping === e.value ? null : e.value;
  }

  get breakout() {
    return this.peopleController.breakout;
  }

  get people() {
    return this.store.peekAll('person').filter((person) => person.active);
  }
}
